import ReactDOM from 'react-dom';

import CalendarPlus from './CalendarPlus';

import type { CalendarConfigProps } from './lib/types';
import type { IShortcodeSettings } from './lib/context/ShortcodeSettingsContext';

const containers = document.querySelectorAll<HTMLElement>('.calendar-plus');

function renderCalendar(container: HTMLElement, config: CalendarConfigProps) {
	ReactDOM.render(<CalendarPlus config={config} />, container);
}

containers.forEach((container, index) => {
	const { api, dateStart, dateEnd, categories, tags, venues, countries, states, cities } = container.dataset;

	// Generate unique instance ID for each calendar
	const instanceId = container.getAttribute('data-instance-id') || `cal-${index}`;

	const shortcodeFilters: Partial<IShortcodeSettings> = (() => {
		try {
			const raw = container.getAttribute('data-props');
			return raw ? JSON.parse(raw) : {};
		} catch (err) {
			console.error('Invalid JSON in data-props:', err);
			return {};
		}
	})();

	const baseFilters: Partial<IShortcodeSettings> = {
		...(categories && { cat: categories }),
		...(tags && { tag: tags }),
		...(venues && { venue: venues }),
		...(countries && { countries }),
		...(states && { states }),
		...(cities && { cities }),
	};

	const filters: IShortcodeSettings = {
		...baseFilters,
		...shortcodeFilters,
	};

	const parsedConfig: CalendarConfigProps = {
		api,
		dateStart,
		dateEnd,
		instanceId,
		filters,
	};

	renderCalendar(container, parsedConfig);
});
